import ListagemDeProduto from './listagem/listagem-de-produto'
import DetalhesDoProduto from './detalhes/detalhes-do-produto'

export default [
    {
        path: '/',
        name: 'produto-listagem',
        component: ListagemDeProduto
    },
    {
        path: '/produto/:id',
        name: 'produto-detalhes',
        component: DetalhesDoProduto
    }
]